function  validatePercentageToTwoDecimal(value) {
    var re = /(^100([,]0{1,2})?)$|(^\d{1,2}([,]\d{1,2})?)$/;
    return re.test(value)
}

export default validatePercentageToTwoDecimal;

